import { HeroLeadGenerationSection } from "components/lead-generation-v2/hero-lead-generation-section/hero-lead-generation-section";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";

import { onlineAdvantageInfoCard } from "data/online-class-advantage";
import { InfoCard } from "components/info-card/info-card";
import { scheduleCard } from "data/schedule";
import { ExploreTeachers } from "components/explore-teachers/explore-teachers";
import { Social } from "components/social/social";
import { getLeadSourceFromPath } from "utils/utils";
import Image from "next/legacy/image";
import {
  FloatingButton,
  FloatingButtonContent
} from "components/tanya-search-block/tanya-search-block.styles";
import { PriceInfoCard } from "components/lead-generation-v2/price-info-card/price-info-card";
import trackEvent from "services/mixpanel/mixpanel";
import { bannerIntentEventNames } from "services/mixpanel/tanya-events";
import WhatAppIcon from "public/assets/whatsappicon.png";
import { BimbelDaftarColearnSEO } from "seo/bimbel-daftar-colearn.seo";

function useHeroSectionInView(ref: React.RefObject<HTMLElement>) {
  const [inView, setInView] = useState(true);
  useEffect(() => {
    if (!ref.current) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.1 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);
  return inView;
}

const BimbelCTAButton: React.FC<{
  testId: string;
  backgroundColor?: string;
}> = ({ backgroundColor = "transparent" }) => {
  const router = useRouter();
  const leadSource = getLeadSourceFromPath(router.pathname);

  const handleBimbelCTAClick = () => {
    trackEvent({
      eventName: bannerIntentEventNames.primaryCTAClicked,
      payload: { leadSource }
    });

    window.location.href =
      "https://api.whatsapp.com/send/?phone=6281919187201&text=Hai%20CoLearn%2C%20mohon%20info%20bimbel%20online%20Matematika&type=phone_number&app_absent=0";
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingBottom: "20px",
        paddingTop: "0px",
        backgroundColor
      }}
    >
      <PriceInfoCard
        onCTAClick={handleBimbelCTAClick}
        ctaTitle="Minta info bimbel"
      />
    </div>
  );
};

const DaftarBimbelColearn: React.FC = () => {
  const heroRef = useRef<HTMLDivElement>(null);
  const heroInView = useHeroSectionInView(heroRef);

  return (
    <>
      <BimbelDaftarColearnSEO />
      <div ref={heroRef}>
        <HeroLeadGenerationSection source="DaftarBimbelColearn" />
      </div>
      {onlineAdvantageInfoCard.map((card, index) => (
        <InfoCard
          key={index}
          {...card}
          backgroundColor="#FFFFFF"
          boldStyle={{
            fontWeight: "900",
            fontSize: "28px",
            fontFamily: "Poppins"
          }}
          isCompact={true}
        />
      ))}
      <BimbelCTAButton testId="info-card-bimbel-button" />
      <ExploreTeachers />
      {scheduleCard.map((card, index) => (
        <InfoCard
          key={index}
          {...card}
          backgroundColor="#ECF6FF"
          isCompact={true}
        />
      ))}
      <BimbelCTAButton
        testId="schedule-card-bimbel-button"
        backgroundColor="#ECF6FF"
      />

      <Social />
      {!heroInView && (
        <FloatingButton
          $show={true}
          $showOnDesktop={true}
          onClick={() => {
            window.location.href =
              "https://api.whatsapp.com/send/?phone=6281919187201&text=Hai%20CoLearn%2C%20mohon%20info%20bimbel%20online%20Matematika&type=phone_number&app_absent=0";
          }}
          style={{
            position: "fixed",
            bottom: 24,
            right: 33,
            zIndex: 1000,
            cursor: "pointer"
          }}
        >
          <Image
            src={WhatAppIcon}
            alt="Whatsapp"
            layout="intrinsic"
            width={30}
            height={30}
          />
          <FloatingButtonContent>Minta info bimbel</FloatingButtonContent>
        </FloatingButton>
      )}
    </>
  );
};

export default DaftarBimbelColearn;
